import AdminWebAPIUtils from 'utils/AdminWebAPIUtils';
import UserWebAPI from 'utils/UserWebAPIUtils';
import UserLocalStorageAPIUtils from 'utils/UserLocalStorageAPIUtils';
import AdminAppDispatcher from 'dispatcher/AdminAppDispatcher';
import AdminConstants from 'constants/AdminConstants';
import { trackUserEvent, EVENTS } from 'helpers/analytics';

const ActionTypes = AdminConstants.ActionTypes;

export default {
  resetPassword(email) {
    AdminWebAPIUtils.resetPassword(email);
  },
  login(username, password) {
    AdminWebAPIUtils.login(username, password);
  },
  logout() {
    trackUserEvent(EVENTS.USER_LOGGED_OUT);
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.LOGOUT,
    });
  },
  getUserProfile(id) {
    UserWebAPI.get(id);
  },
  getSalespeople() {
    const query = { sales: true, active: true };
    UserWebAPI.getSalesReps(query);
  },
  addAdminUser(user) {
    UserWebAPI.addAdminUser(user);
  },
  getAdminUsers(query) {
    UserWebAPI.getAdminUsers(query);
  },
  deactivateUsers(users, params) {
    return UserWebAPI.deactivateUsers(users, params);
  },
  updateUsersRoles(users, params) {
    return UserWebAPI.updateUsersRoles(users, params);
  },
  activateUsers(users, params) {
    return UserWebAPI.activateUsers(users, params);
  },
  addCargomaticUser(user) {
    UserWebAPI.addCargomaticUser(user);
  },
  addCarrier(carrier) {
    UserWebAPI.addCarrier(carrier);
  },
  addVendor(vendor) {
    UserWebAPI.addVendor(vendor);
  },
  addConsignee(consignee) {
    UserWebAPI.addConsignee(consignee);
  },
  findUsers(query) {
    UserWebAPI.findUsers(query);
  },
  addDriver(driver) {
    UserWebAPI.addDriver(driver);
  },
  update(id, atts) {
    UserWebAPI.update(id, atts);
  },
  setMarketsPeference(markets) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.USER_SET_MARKETS_PREFERENCE,
      markets,
    });
    UserLocalStorageAPIUtils.setMarketsPreference(markets);
  },
  getMarketsPreference() {
    const savedMarketsPreference =
      UserLocalStorageAPIUtils.getMarketsPreference();
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.USER_RECEIVE_MARKETS_PREFERENCE,
      markets: savedMarketsPreference,
    });
  },
  updateNotificationEvent(id, notificationEvent) {
    UserWebAPI.updateNotificationEvent(id, notificationEvent);
  },
  updateNotificationRecipients(id, notificationEvent) {
    UserWebAPI.updateNotificationRecipients(id, notificationEvent);
  },
};
